$().ready(function(){
  $("tbody").on( "click", "tr[data-link]", function() {
    window.location = this.dataset.link;
  })
});
